// Todo: In Code Cleanup, rename parent folder UserBarResponsive to UserBar once old UserBar is no longer used, deleted, its toggle removed and put into graveyard.
import UserBar from './UserBar.container';

export default UserBar;
